<template>
  <div class="landingpage">
    <div class="content-wrapper">

      <div class="landingpage-info">
        <div class="landingpage-intro">
          <h2>CHRIST <br class="mobile-title-lb" /> Online-Uhren&Schmuck-Service</h2>
          <p>
            Mit leidenschaftlicher und sorgfältigster Handarbeit werden Ihre Uhren und Schmuckstücke aufbereitet. <br />
            Lassen Sie sich von unserem herausragenden Service überzeugen! <br />
            <i>Derzeit kann unser Schmuck-Service nur in unseren Filialen in Anspruch genommen werden. 
            Hier geht’s zum Filialfinder: <a href="https://www.christ.de/store-finder">Alle CHRIST Juweliere & Uhrmacher Filialen in deiner Nähe</a></i>
          </p>
          <router-link :to="{ name: 'Diagnosis' }" id="router-links">
            <b-button variant="primary">
              Service starten
            </b-button>
          </router-link>
        </div>

        <div class="landingpage-description">
          <p>
            Neben dem vielfältigen Angebot an Service-Leistungen, bieten wir Ihnen hier ebenfalls eine Prüfung Ihrer
            Reparaturwünsche im Rahmen von Gewährleistungs- und Uhrenschutzfällen an.
            <strong>Bitte beachten Sie, dass hier ausschließlich Servicefälle für Lieferadressen
              in Deutschland entgegengenommen werden.</strong><br /><strong>Bitte beachten Sie, dass Ihre Sendung nur bis
              500 EUR Warenwert versichert ist. Bei einem höheren Warenwert bitten wir um direkte Beauftragung der
              Reparatur in einer unserer Filialen.</strong><br />Servicegutscheine bzw. Batteriegutscheine können
            nur in einer Filiale eingelöst werden, nicht im
            Online-Uhren&Schmuck-Service.
          </p>
        </div>
      </div>
    </div>

    <div class="landingpage-help">
      <h3>So funktioniert der Online-Uhren&Schmuck-Service</h3>
      <p>Hier finden Sie Fragen und Antworten rund um den CHRIST Online-Uhren&Schmuck-Service</p>
      <router-link :to="{ name: 'Help' }" id="router-links">
        <b-button variant="outline-primary">
          Zum Hilfe-Bereich
        </b-button>
      </router-link>
      <p class="help-contact">Sie haben Fragen vorab? Wenden Sie sich gern an
        <a href="mailto:reparaturservice@christ.de?subject=Anfrage zu einem Auftrag&body=Bitte beschreiben Sie Ihr Anliegen"
          target="_blank">reparaturservice@christ.de</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Landingpage",
  mounted() { },
  methods: {
  }
}
</script>
